import {CookieService} from '../services/cookie.service';

export class CrossDomainTracker {

    static readonly QUERY_PARAM_NAME = 'fplc';
    static readonly COOKIE_NAME = 'FPLC';

    public static setFPLCCookie(): void {
        let currentUrl: URL = new URL(window.location.href);
        let fplcValue: string = currentUrl.searchParams.get(CrossDomainTracker.QUERY_PARAM_NAME);

        if (fplcValue && fplcValue !== 'undefined') {
            let cookieDomain = currentUrl.host.replace(/^([a-z]{1,3}\.)/i, '.');

            CookieService.setCookie(CrossDomainTracker.COOKIE_NAME, encodeURIComponent(fplcValue), 30, cookieDomain);
        }
    }
}

CrossDomainTracker.setFPLCCookie();
